














































import { Component, Vue } from 'vue-property-decorator'
import { AuthModule } from '@/store/Auth/AuthModule';
import { AppModule } from '@/store/Auth/AppModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import VerifyMeRequest from '@/models/Auth/Me/VerifyMeRequest';
import LoginPasswordRequest from '@/models/Settings/Users/LoginPasswordRequest';
import LoginOtpRequest from '@/models/Settings/Users/LoginOtpRequest';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import ForgotPasswordRequest from '@/models/Settings/Users/ForgotPasswordRequest';

@Component({ name: 'Login', components: { Alert }, metaInfo: { title: 'Login' } })
export default class extends Vue {

    email: string = '';
    password: string = '';
    otp: string = '';

    public isPasswordVisible: boolean = false;
    public isOtpVisible: boolean = false;

    submitForm() {
        // For a normal password login
        if (this.isPasswordVisible) {
            this.loginPassword();
        }
        // For a One Time Password login
        else if (this.isOtpVisible) {
            this.loginOtp();
        }
        // Else just verify email is correct before showing the next step
        else {
            this.verify();
        }
    }

    get isErrorVisible() {
        return AppModule.lastErrorVisible;
    }

    get isLoadingLogin() {
        return AuthModule.loadingLogin;
    }

    async verify() {
        const request = new VerifyMeRequest();
        request.email = this.email;

        await AuthModule.verifyMe(request)
        if (AuthModule.verifyMeResponse === null) {
            // User not found - an error message will be shown
            this.email = '';
            this.password = '';
            this.isPasswordVisible = false;
            return;
        }

        this.isPasswordVisible = true;
    }

    async loginPassword() {
        const request = new LoginPasswordRequest();
        request.email = this.email;
        request.password = this.password;
        request.institutionId = AuthModule.verifyMeResponse.institutionId;

        await AuthModule.loginPassword(request);
        if (!AuthModule.isAuthenticationComplete) {
            // Login has either failed or there is a next step
            if (AuthModule.loginNextStepName === "otp") {
                this.isPasswordVisible = false;
                this.isOtpVisible = true;
            }
            return;
        }
        else {
            // Login success, get the user profile
            await AuthModule.getMe();
            if (AuthModule.me === null) {
                // Get profile failed - error will be displayed
                return;
            }

            // If there is a redirect, go to that specific page otherwise just go to the dashboard
            if (this.$route.query.redirect !== undefined) {
                this.$router.push({ path: this.$route.query.redirect.toString()});
                return;
            }
            else {
                this.$router.push({ name: PageNames.Dashboard });
            }
        }

        return;
    }

    async loginOtp() {
        const request = new LoginOtpRequest();
        request.email = this.email;
        request.otp = this.otp;
        request.loginId = AuthModule.loginId;
        request.institutionId = AuthModule.verifyMeResponse.institutionId;

        await AuthModule.loginOtp(request);
        if (!AuthModule.isAuthenticationComplete) {
            // Authentication failed - error will be displayed
            return;
        }
        else {
            // Login success, get the user profile
            await AuthModule.getMe();
            if (AuthModule.me === null) {
                // Get profile failed - error will be displayed
                return;
            }

            // If there is a redirect, go to that specific page otherwise just go to the dashboard
            if (this.$route.query.redirect !== undefined) {
                this.$router.push({ path: this.$route.query.redirect.toString()});
                return;
            }
            else {
                this.$router.push({ name: PageNames.Dashboard });
            }
        }

        return;
    }

    async resetPassword() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Reset",
            buttonFalseText: "Cancel",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary"
        }
        const result = await this.$confirm('This will send an email containing a reset link to ' + this.email + '. Are you sure you want to reset the password for this account?', options);

        if (result) {
            const request = new ForgotPasswordRequest();
            request.email = this.email;
            request.institutionId = AuthModule.verifyMeResponse.institutionId;
            await AuthModule.forgotPassword(request);
        }
    }
}
